import request, { convertToFormData } from '../utils/request'

/**
 * 请求参数说明
 * GET/DELETE:
 * fun(replacePrams, query)
 * @param replacePrams 替换参数(从左到右依次替换)
 * @example /api/activities/{id}/dy/{dyId} + {id: 1, dyId: 2} => /api/activities/1/dy/2
 * @param query filter
 * @example /api/activities/1/dy/2 + { orderBy: 'DESC' } => /api/activities/1/dy/2?orderBy=DESC
 *
 * POST/PUT:
 * fun(replacePrams, data)
 * 同上
 *
 * 注意：如果无replacePrams默认传入{}
 * @example saveSales({}, { name, age, phone })
 */

/**
 * 根据活动ID获取活动信息
 */
export function getActivityById(replacePrams) {
  return request('/api/activities/{id}', {
    method: 'GET',
    replacePrams,
  })
}

export function unfollowActivity(replacePrams) {
  return request('/api/activities/{id}/followers', {
    method: 'DELETE',
    replacePrams,
  })
}

export function followActivity(replacePrams) {
  return request('/api/activities/{id}/followers', {
    method: 'POST',
    replacePrams,
  })
}

export function unfollowUser(replacePrams) {
  return request('/api/organization/{id}/followers', {
    method: 'DELETE',
    replacePrams,
  })
}

export function followUser(replacePrams) {
  return request('/api/organization/{id}/followers', {
    method: 'POST',
    replacePrams,
  })
}

export function saveSales(data) {
  return request('/api/sales', {
    method: 'POST',
    body: data,
  })
}

export function getDynamicByActId(query) {
  return request('/api/dynamic', {
    method: 'GET',
    query,
  })
}

export function getDynamicInfo(replacePrams) {
  return request('/api/dynamic/{id}', {
    method: 'GET',
    replacePrams,
  })
}

export function getAnswersByDynId(query) {
  return request('/api/answers', {
    method: 'GET',
    query,
  })
}

export function getUserStatus() {
  return request('/api/userStatus', {
    method: 'GET',
  })
}

export function getWeals(query) {
  return request('/api/weal/contents', {
    method: 'GET',
    query,
  })
}

export function getWealTypes() {
  return request('/api/weal/types', {
    method: 'GET',
  })
}

export function getWowBadge() {
  return request('/api/badge', { method: 'GET' })
}

export function setWowBadge(data) {
  return request('/api/badge', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: convertToFormData(data),
  })
}

export function getCurrentUser() {
  return request('https://www.zhihu.com/api/v4/me', { method: 'GET' })
}

export function getIdeaByDynId(query) {
  return request('/api/dynamic/pin', {
    method: 'GET',
    query,
  })
}

export function likeIdeaItem(pinId, isLike) {
  return request(`https://www.zhihu.com/api/v4/pins/${pinId}/reactions`, {
    method: isLike ? 'POST' : 'DELETE',
    body: isLike ? convertToFormData({ type: 'like' }) : null,
  })
}

// 首页获取 banner
export function getIndexImage(query) {
  return request('/api/weal/contents', {
    method: 'GET',
    query,
  })
}



// WEBPACK FOOTER //
// ./src/services/index.js